<template>
    <div>
        <page-header title="بلاگ" create-url="/posts/create"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="posts"
                               :items="posts"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getPosts"
                               @delete="deletePost"
                               @statusChanged="statusChanged"
                               :actions="actions"
        ></table-with-pagination>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";

export default {
    name: "PostList",

    components: {SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'عنوان فارسی', value: 'fa_title', align: 'center'},
                {text: 'عنوان انگلیسی', value: 'en_title', align: 'center'},
                {text: 'عکس', value: 'image_url', align: 'center'},
                {text: 'تعداد بازدید', value: 'visits', align: 'center'},
                {text: 'وضعیت', value: 'status', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],

            posts: null,

            actions: [
                {
                    icon: 'mdi-comment',
                    color: 'primary',
                    route_name: 'post-comments',
                    route_param: 'fa_slug',
                    tooltip: 'مدیریت نظرات'
                },
                {
                    icon: 'mdi-pencil',
                    color: 'warning',
                    route_name: 'update-post',
                    route_param: 'fa_slug'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'fa_slug',
                    delete_confirm: true,
                }
            ],

            filters: [
                {
                    type: 'text',
                    name: 'needle',
                    label: 'جستجو',
                },
                {
                    type: 'select',
                    name: 'status',
                    label: 'وضعیت',
                    select_text: 'text',
                    select_value: 'value',
                    select_items: [
                        {text: 'فعال', value: '1'},
                        {text: 'غیر فعال', value: '0'},
                    ],
                },
            ],
            searchValues: '',
        }
    },

    mounted() {
        this.getPosts(parseInt(this.$route.query.page ?? "1"))
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getPosts()
            })
        },

        getPosts(page = 1) {
            this.$store.dispatch("getPaginatedPosts", page + this.searchValues)
                .then((res) => {
                    this.posts = res.data
                })
        },

        deletePost(slug) {
            this.$store.dispatch("deletePost", slug)
                .then(() => {
                    this.getPosts(this.posts.pagination.current_page)
                })
        },

        statusChanged(item) {
            this.$store.dispatch("togglePostStatus", item.fa_slug)
                .then(() => {
                    this.getPosts(this.posts.pagination.current_page)
                })
        }
    }
}
</script>

<style scoped>

</style>